










































import { Component, Vue } from 'vue-property-decorator';
import { OrgsApi } from '@/api';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import vSelect from 'vue-select';
import addSite from '@/components/add business objects/addSite.vue';
import OrgSuggest from '@/components/form pickers/orgSuggest.vue';
import { ApiUtils } from '@/common/ApiUtils';
import Toast from '@/components/display/toast.vue';

@Component({
	components: {
		OrgSuggest,
		addSite,
		secondaryNav,
		vSelect,
	},
})
export default class SiteCreate extends Vue {
	private toast: Toast = new Toast();
	public org = { id: null, name: '', sites: [] };
	public site: any = {
		id: undefined,
		orgId: undefined,
		name: '',
		address: { fullAdr: '', region: '', location: '' },
	};
	public loading: boolean = false;

	public async created() {
		const orgId = this.$route.params.orgId;
		if (orgId !== undefined) {
			this.loading = true;
			try {
				const response = await new OrgsApi().getOrgById(parseInt(orgId, 10), [
					'admin',
					'address',
					'sites',
					'subscription',
				]);
				(this.org as any) = response.data;
			} catch (e) {
				const { errorMessage } = ApiUtils.handleApiError(e, `Cannot find org by id "${orgId}"`);
				this.toast.makeToast(errorMessage, 'Error', 'danger');
			}
		}
		this.loading = false;
	}

	public load() {
		this.$router.push({ name: 'sites.view', params: { siteId: this.site.id } });
	}
}
